import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

function MascaraCPF(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask={false}
        />
    )
}

MascaraCPF.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

export default MascaraCPF;